export default __webpack_public_path__ + "static/media/ESSC32LSAP01_1920x1080.f85fe76b.jpg";